import { render, staticRenderFns } from "./CompareItemsTotalBox.vue?vue&type=template&id=dcb5b704&"
import script from "./CompareItemsTotalBox.vue?vue&type=script&lang=js&"
export * from "./CompareItemsTotalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports